import { d as defineCustomElement } from '../chunks/vidstack-B11i_cNc.js';
import { a as MediaPlayerElement, M as MediaProviderElement } from '../chunks/vidstack-BkWDW_KT.js';
import '../chunks/vidstack-BPJwxG0c.js';
import '../chunks/vidstack-CNLrsPpJ.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BnqIpPdq.js';
import '../chunks/vidstack-NiSULkLR.js';
import '../chunks/vidstack-CzvK2UwB.js';
import '../chunks/vidstack-COCzjeeM.js';
import '../chunks/vidstack-CUVgUi9M.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-DM_McBs5.js';
import '../chunks/vidstack-ksPACRiU.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
